import { __makeTemplateObject } from "tslib";
import { css } from 'styled-components';
import { Box } from '../Box';
import { themeGet, createComponent } from '../utils';
var StyledCard = createComponent({
    name: 'Card',
    as: Box,
    style: function (_a) {
        var shadow = _a.shadow, theme = _a.theme;
        return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background: white;\n    box-shadow: ", ";\n    border-radius: ", "px;\n    overflow: hidden;\n    border: 1px solid ", ";\n  "], ["\n    background: white;\n    box-shadow: ", ";\n    border-radius: ", "px;\n    overflow: hidden;\n    border: 1px solid ", ";\n  "])), shadow ? themeGet('shadow.soft', 'none') : 'none', themeGet('radius', 0), theme.colors.greyLight);
    },
});
var Card = StyledCard;
Card.defaultProps = {
    shadow: false,
};
Card.Footer = createComponent({
    name: 'CardFooter',
    as: Box,
    style: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding: 16px;\n  "], ["\n    padding: 16px;\n  "]))),
});
var cardFooterClass = Card.Footer.toString();
Card.Body = createComponent({
    name: 'CardBody',
    as: Box,
    style: function () { return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding: 16px;\n\n    & + ", " {\n      padding-top: 0px;\n    }\n  "], ["\n    padding: 16px;\n\n    & + ", " {\n      padding-top: 0px;\n    }\n  "])), cardFooterClass); },
});
var cardBodyClass = Card.Body.toString();
Card.Header = createComponent({
    name: 'CardHeader',
    as: Box,
    style: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding: 16px;\n    font-weight: 700;\n\n    & + ", " {\n      padding-top: 0px;\n    }\n  "], ["\n    padding: 16px;\n    font-weight: 700;\n\n    & + ", " {\n      padding-top: 0px;\n    }\n  "])), cardBodyClass),
});
export default Card;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=Card.js.map